import { FieldConfig } from 'constants/FumigationCompanyConstants/FumigationCompanyConstants';

const CustomerInformationConstants = {

    SECTION_TITLE: 'Customer / Premises Information',

    HOURS: {
        Close: [
            '(AM = 7:00 AM to 11:30 AM)',
            '(PM = 12:00 PM to 4:00 PM)',
            '(AD = All Day 7:00 AM - 8:00 PM)',
        ],
        Restore: [
            '(AM = 7:00 AM to 12:00 PM)',
            '(PM = 12:00 PM to 8:00 PM)',
            '(AD = All Day 7:00 AM - 8:00 PM)',
        ],
        'Saturday Restore': ['(After 10:00 AM)'],
        Cancellation: ['To cancel same day orders, please call (800) 427-2200'],
    },

    CUSTOMER_NAME: {
        label: 'Customer Name Last, First Name Business Name',
        name: 'Customer Name Last, First Name Business Name',
        sqlColumn: 'customerInformation',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    SERVICE_ADDRESS: {
        label: 'Service Address',
        name: 'Service Address',
        sqlColumn: 'serviceAddress',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    APT_OR_SPACE: {
        label: 'Apt. or Space Fraction',
        name: 'Apt. or Space Fraction',
        sqlColumn: 'aptOrSpaceFraction',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    ORDER_SCHEDULE_CANCEL: {
        label: 'Order Schedule Cancel',
        name: 'Order Schedule Cancel',
        sqlColumn: 'orderScheduleCancel',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    CLOSE_ORDER_DATE: {
        label: 'Close Order Schedule Date',
        name: 'Close Order Schedule Date',
        sqlColumn: 'closeOrderScheduleDate',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    CLOSE_TIME: {
        label: 'Time',
        name: 'Time',
        sqlColumn: 'time',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    RESTORE_ORDER_DATE: {
        label: 'Restore Order Schedule Date',
        name: 'Restore Order Schedule Date',
        sqlColumn: 'restoreOrderScheduleDate',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    RESTORE_TIME: {
        label: 'Time',
        name: 'Time',
        sqlColumn: 'time2',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    TOTAL_METERS: {
        label: 'Total # of Mtrs.',
        name: 'Total # of Mtrs.',
        sqlColumn: 'totalNumberOfMtrs',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    ACCESS_ARRANGEMENTS: {
        label: 'Access Arrangements',
        name: 'Access Arrangements',
        sqlColumn: 'accessArrangements',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    CODE_TYPE: {
        label: 'Code Type',
        name: 'Code Type',
        sqlColumn: 'codeType',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    CODE: {
        label: 'Code',
        name: 'Code',
        sqlColumn: 'code',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    ADDITIONAL_ACCESS_INFO: {
        label: 'Additional Access / Address Information',
        name: 'Additional Access / Address Information',
        sqlColumn: 'additionalAccessOrAddressInformation',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    LABEL_ADDITIONAL_ACCESS_NOTE:
        'Additional Access / Address Information - Please enter pertinent information only. ' +
        'Any additional text, such as "Please Cancel" or "Thank you", may delay the processing of your order.',
};

export default CustomerInformationConstants;
